export { Heading } from "./Heading"
export { Faqs } from "./Faqs"
export { BackToTop } from "./BackToTop"
export { BackButton } from "./BackButton"
